import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { pageTransitions } from '../../../../animations/page-transitions';
import { DocumentLastConnectionDateFilter, DynamicDatacenterFilter,
	DocumentLastConnectionDateFilterType } from '../../../../models/datacenter-filters';

@Component({
	selector: 'copo-document-last-connection-date-filter',
	templateUrl: './document-last-connection-date-filter.component.html',
	styleUrl: './document-last-connection-date-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, MatIconModule, MatRippleModule, MatCheckboxModule, MatButtonModule]
})
export class DocumentLastConnectionDateComponent implements DynamicDatacenterFilter<DocumentLastConnectionDateFilter>,
		OnInit {
	@Input() filter?: DocumentLastConnectionDateFilter;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;
	isFilterTrueOnInit = false;
	isChecked = false;
	ngOnInit() {
		if (!this.filter) {
			return;
		}
		if (this.filter.getValues()[0].length === 1) {
			this.isFilterTrueOnInit = true;
		}
		for (const item of this.filter.getValues()[0]) {
			this.isChecked = item.selected;
		}
	}

	removeValue() {
		if (!this.filter) {
			return;
		}
		this.removeFilter.emit();
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return { id: this.filter.filterId, values: this.filter.getValues() };
		}
		return undefined;
	}

	buttonClick(checkboxValue: DocumentLastConnectionDateFilterType) {
		checkboxValue.selected = !checkboxValue.selected;
		this.isChecked = !checkboxValue.selected;
	}
}
